import { httpResource, HttpResourceOptions } from '@angular/common/http';
import { signal } from '@angular/core';

export function resourceTrigger<T>(
  request: string | (() => string | undefined),
  options: HttpResourceOptions<T, unknown>
) : {
  load: () => void;
} & ReturnType<typeof httpResource<T>> {
  const triggerSignal = signal<boolean>(false);

  const load = () => triggerSignal.set(true);

  const resource = httpResource<T>(() => {
    if (!triggerSignal()) return undefined as any;
    const req = typeof request === 'function' ? request() : request;
    return req;
  }, options);
  return Object.assign(resource, { load });
  return { ...resource, load };
}

